// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * EventType : represents the type of an event
 */
export var EventType;
(function (EventType) {
    EventType["EVENT_TYPE_UNSPECIFIED"] = "EVENT_TYPE_UNSPECIFIED";
    EventType["EVENT_TYPE_INFO"] = "EVENT_TYPE_INFO";
    EventType["EVENT_TYPE_ERROR"] = "EVENT_TYPE_ERROR";
})(EventType || (EventType = {}));
export var EventType_index;
(function (EventType_index) {
    EventType_index[EventType_index["EVENT_TYPE_UNSPECIFIED"] = 0] = "EVENT_TYPE_UNSPECIFIED";
    EventType_index[EventType_index["EVENT_TYPE_INFO"] = 1] = "EVENT_TYPE_INFO";
    EventType_index[EventType_index["EVENT_TYPE_ERROR"] = 2] = "EVENT_TYPE_ERROR";
})(EventType_index || (EventType_index = {}));
